import { Tooltip as AntdTooltip } from 'antd';
import styled from 'styled-components';

export const Tooltip = styled(AntdTooltip)``;
